import { useEventSubscribe } from "../../events/index.ts";
import { useEditingCss } from "./EditingCssPropertiesContext.ts";
import { propertiesEventTypes, type DimensionsUpdateEventOptions } from "./propertiesEventTypes.ts";

type Props = {
  nodeId: number;
};

/**
 * Subscribes to dimension update events from DimensionsCalculator and updates
 * the node's CSS width/height properties through the EditingCssPropertiesContext.
 * This ensures dimension updates are routed correctly when editing element states.
 */
export const DimensionsUpdateSubscriber = ({ nodeId }: Props) => {
  const { onCssPropertiesChange } = useEditingCss();

  useEventSubscribe(
    propertiesEventTypes.UPDATE_NODE_DIMENSIONS,
    ({ nodeId: eventNodeId, width, height }: DimensionsUpdateEventOptions) => {
      if (eventNodeId !== nodeId) return;
      onCssPropertiesChange({ width, height });
    },
  );

  return null;
};
